/**
 * Platform enum representing the different platforms the app can run on
 */
export enum Platform {
    iOS = 'ios',
    Android = 'android',
    Web = 'web'
} 

/**
 * OnboardingMethod enum representing different methods for onboarding users
 */
export enum OnboardingMethod {
    ClockFocused = 'ClockFocused',  // land on clock if not logged in, signup goes to clock
    IndexPageHelper = 'IndexPageHelper', // land on signup page if not logged in, signup goes to Helper index page
    ClockFocusedToUserHome = 'ClockFocusedToUserHome', // land on clock if not logged in,signup goes to user home
    Wizard = 'Wizard' // land on wizard if not logged in, signup goes to Clock
}

export enum SkipNameInfo {
    Skip = 'Skip',
    GetInOnboarding = 'GetInOnboarding',
}

export enum SwitcherType {
    RightSide = 'RightSide',
    PillToggle = 'PillToggle'
}

/**
 * API data type for sending an invite
 */
export type InviteData = {
    recipientEmail: string
    recipientName: string
    inviterName: string
}

export interface InviteRequest {
    recipient: string
    subject: string
    link: string
}

// MicroWizard types
export interface MicroWizardStep {
  id: string;
  title: string;
  type: 'text' | 'image' | 'video' | 'custom';
  icon?: {
    type: 'emoji' ;
    emoji?: string;
  };
  content: {
    // For text type
    text?: string;
    
    // For image type
    imageUrl?: string;
    imageAlt?: string;
    
    // For video type
    videoUrl?: string;
    autoPlay?: boolean;
    
    // For custom type
    component?: any;
    props?: Record<string, any>;
  };
  actions: {
    primary?: {
      label: string;
      action: string | (() => void);
    };
    secondary?: {
      label: string;
      action: string | (() => void);
    };
  };
  hideNavigation?: boolean;
}

export interface MicroWizardConfig {
  id: string;
  steps: MicroWizardStep[];
  persistent?: boolean;
  dismissible?: boolean;
  startAt?: number;
  onComplete?: () => void;
  onDismiss?: () => void;
}

export interface MicroWizardMachineContext {
  currentStepIndex: number;
  steps: MicroWizardStep[];
  completed: boolean;
}